import { toLocalISO } from '../components/SharedFormFields';

export const TYPE_OF_PURCHASE_REQ_FORM = 'Purchase';

export const DEFAULT_VEHICAL_CHECK_LIST = {
  goodVisibility: '',
  drivingControlsSeat: '',
  windscreenWasherWipers: '',
  tachographCalibrated: '',
  allInstruments: '',
  noAirleaksOrPressureDrop: '',
  vehicleSittingSquare: '',
  taxInsurance: '',
  wheelsGoodCondition: '',
  allLightsReflectors: '',
  exhaustSecure: '',
  airElectrical: '',
  vehicleAccess: '',
  vehicleBody: '',
  fifthWheel: '',
  trailerParkBrake: '',
  airSuspension: '',
  engineOil: '',
  steeringAndBrakes: '',
  loadsSecured: '',
  tachographSpeedometer: '',
  abSandEBS: '',
  other: '',
  checkRolloverCovers: '',
};

//--- new
export const DEFAULT_DRIVER_DATA = {
  dateAndTime: toLocalISO(),
  employeeName: '',
  task: '',
  vehicle: '',
  trailer: '',
  mileageReadingKM: '',
  vehicleCheckListCompleted: 0,
  additionalInformation: '',
  geolocationLatitude: null,
  geolocationLongitude: null,
};
